( function( $ ) {	

	window.lafMagFunctions = window.lafMagFunctions ? window.lafMagFunctions : {};
	const LMF = window.lafMagFunctions;	
	
	LMF.init = function(){

		// Bind "Load More" Functionality for Posts (Must be localized to theme)
		let currentPage = 1;
		let postLoopCount = 1;

        $('#LafMagLoadMore a').on('click', function() {

			let catID = $(this).attr('data-catid');
			let tagID = $(this).attr('data-tagid');
			let customError = 'An error has occurred and your request cannot be processed. Please try again.'
			currentPage++; 

			// Set load cover
			$('.lafmag-content-load').fadeIn(500);

			$.ajax({
				type: 'POST',
				url: lafmagAjax.ajaxurl,
				dataType: 'json',
				data: {
					action: 'lafmag_load_more',
					paged: currentPage,
					postLoopCount: postLoopCount,
					catID: catID,
					tagID: tagID
				},
				success: function (res) {

					// Remove "Load More" button if there are no additional posts
					if( currentPage >= res.max ) {
						$('#LafMagLoadMore').hide();
					}

					// Bind Post data
					$('.lafmag-ajax-posts-list').append(res.html);

					// Manage scroll
					elementTop = $('.ajax-post-set' + postLoopCount).first().offset().top;
					scrollToElement( elementTop );
					postLoopCount++;

					// Remove load cover
					$('.lafmag-content-load').fadeOut(500);
				},
				error: function () {

					// Append custom error message
					$('.lafmag-ajax-posts-list').append( '<p>' + customError + '</p>' );

					// Remove load cover
					$('.lafmag-content-load').fadeOut(500);
				}
			});
		});
		
		// Open Drop-Down Menu (Mobile Navigation)
		$( document ).on( 'keypress click', '.lafmag-control-mobile-menu', this, function ( e ) {
			e.preventDefault();
			if ( inputOptions( e, 'all' ) ) {
				$('body').toggleClass('lafmag-menu-open');
			}
		} );
		
		// Open Drop-Down Menu (Desktop Navigation)
		$( document ).on( 'keypress click', '.lafmag-control-toggle-ddm', this, function ( e ) {
			e.preventDefault();
			if ( inputOptions( e, 'click' ) ) {
				$('body').toggleClass('lafmag-menu-open');
			}
			else if ( inputOptions( e, 'keypress' ) ) {
				$('body').toggleClass('lafmag-menu-open');

				if( $('body').hasClass('lafmag-menu-open') ){
					$('.lafmag-control-close-ddm').focus();
				}
			}
		} );

		// Close Drop-Down Menu (Mobile & Desktop Menu)
		$( document ).on( 'keypress click', '.lafmag-control-close-ddm', this, function ( e ) {
			e.preventDefault();
			if ( inputOptions( e, 'click' ) ) {
				$('body').toggleClass('lafmag-menu-open');
			}
			else if ( inputOptions( e, 'keypress' ) ) {
				$('body').toggleClass('lafmag-menu-open');

				if( !$('body').hasClass('lafmag-menu-open') ){
					$('.lafmag-control-toggle-ddm').focus();
				}
			}
		} );

		// Footer Scroll to Top Block
		$( document ).on( 'keypress click', '.lafmag-control-scroll-top', this, function ( e ) {
			e.preventDefault();
			if ( inputOptions( e, 'all' ) ) {
				scrollToTop();
			}
		} );

		// Callable scroll function
		function scrollToTop(){
			let body = $("html, body");
			body.stop().animate({scrollTop:0}, 500, 'swing');
		}

		// Callable scroll to element function
		function scrollToElement( elementTop ){
			let body = $("html, body");
			body.stop().animate({scrollTop:elementTop}, 500, 'swing');
		}

		// Input Options

		function inputOptions( event, type ) {

			let keyEnter = 13;
			let keySpace = 32;
	
			if(type === 'all') {
				if( event.which === keyEnter || event.which === keySpace || event.type === 'click' ) {
					return true;
				}
			} 
			if(type === 'keypress') {
				if( event.which === keyEnter || event.which === keySpace ) {
					return true;
				}
			} 
			if(type === 'click') {
				if( event.type === 'click' ) {
					return true;
				}
			} 
			return false;
		}

	}
	
	// Init theme functions
	LMF.init();
	
} )( jQuery );